// src/plugins/pendo.js

const PendoPlugin = {
    install(app, options = {}) {
        const {
            id,
            getUserData,
            getClientData,
            getRoles = (user) => user.roles ? user.roles.map(({ name }) => name) : [],
            watchers = [], // Array of functions that will be called with updatePendo function
            isEnabled = () => process.env.VUE_APP_PENDO_ID
        } = options;

        if (!isEnabled()) {
            console.log('Pendo feature is disabled');
            return;
        }

        let pendoInitialized = false;

        const updatePendo = () => {
            const user = getUserData();
            const client = getClientData();

            if (!user || !client) return;

            const roles = getRoles(user);

            const visitorData = {
                id: user.auth0Id || user.id,
                email: user.email,
                roles: roles
            };

            const accountData = {
                id: client.clientId || client.id,
                name: client.client || client.name,
            };

            if (!window.pendo) {
                console.warn('Pendo script is not loaded');
                return;
            }

            if (!pendoInitialized) {
                window.pendo.initialize({
                    visitor: visitorData,
                    account: accountData
                });
                console.log('Pendo initialized');
                pendoInitialized = true;
            } else {
                window.pendo.updateOptions({
                    visitor: visitorData,
                    account: accountData
                });
                console.log('Pendo updated');
            }
        };

        if (!pendoInitialized) {
            new Pendo(id);
        }

        // Initial update
        updatePendo();

        // Set up watchers
        watchers.forEach(watcher => watcher(updatePendo));

        // Vue 3 specific: provide a composable if needed
        if (app.provide) {
            app.provide('pendo', {
                updatePendo
            });
        }
    }
};

class Pendo {
    constructor(id) {
        (function(apiKey){
            (function(p,e,n,d,o){var v,w,x,y,z;o=p[d]=p[d]||{};o._q=o._q||[];
                v=['initialize','identify','updateOptions','pageLoad','track'];for(w=0,x=v.length;w<x;++w)(function(m){
                    o[m]=o[m]||function(){o._q[m===v[0]?'unshift':'push']([m].concat([].slice.call(arguments,0)));};})(v[w]);
                y=e.createElement(n);y.async=!0;y.src='https://cdn.eu.pendo.io/agent/static/'+apiKey+'/pendo.js';
                z=e.getElementsByTagName(n)[0];z.parentNode.insertBefore(y,z);})(window,document,'script','pendo');
        })(id);
    }
}

export default PendoPlugin;
